
export const splitCamelCase = (s) => s.replace(/([a-z])([A-Z])/g, '$1 $2');
